import { render } from "./VideoPopupWindow.vue?vue&type=template&id=2f9f14b0"
import script from "./VideoPopupWindow.vue?vue&type=script&lang=js"
export * from "./VideoPopupWindow.vue?vue&type=script&lang=js"

import "./VideoPopupWindow.vue?vue&type=style&index=0&id=2f9f14b0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__